import { Action, createReducer, on } from "@ngrx/store";
import * as _ from "lodash";

import { VendorGroup } from "../../../definitions/vendor-group";
import { ConsumerActions } from "../../actions/consumer.actions";
import { VendorGroupsState } from "../../models/consumer/vendor-groups-state";

const initialState: VendorGroupsState = {
	loading: true
};

const reducer = createReducer(
	initialState,
	on(ConsumerActions.vendorGroups.getApi, (state) => _.set(_.cloneDeep(state), "loading", true)),
	on(ConsumerActions.vendorGroups.getSuccess, (state, { vendorGroups, loading, hasLoaded }) => ({
		...state,
		vendorGroups,
		loading,
		hasLoaded,
		error: null
	})),
	on(ConsumerActions.vendorGroups.invalidate, () => initialState),
	on(ConsumerActions.vendorGroups.createSuccess, (state, vendorGroup) =>
		addVendorGroupToState(state, vendorGroup)
	),
	on(ConsumerActions.vendorGroups.updateSuccess, (state, vendorGroup) =>
		updateState(state, vendorGroup)
	),
	on(ConsumerActions.vendorGroups.getFail, (state, action) =>
		_.merge(_.cloneDeep(state), _.omit(action, "type"))
	)
);

function updateState(state: VendorGroupsState, vendorGroup: VendorGroup) {
	return {
		...state,
		vendorGroups: state.vendorGroups.map((item) =>
			item.id === vendorGroup.id
				? {
						...item,
						name: vendorGroup.name,
						justification: vendorGroup.justification,
						vendors: vendorGroup.vendors,
						vendorIds: vendorGroup.vendorIds
					}
				: item
		)
	};
}

function addVendorGroupToState(state: VendorGroupsState, vendorGroup: VendorGroup) {
	return {
		...state,
		vendorGroups: [...(state.vendorGroups || []), vendorGroup]
	};
}

export function vendorGroupsReducer(state: VendorGroupsState, action: Action): VendorGroupsState {
	return reducer(state, action);
}
